import { createSlice } from '@reduxjs/toolkit';
import { defaultLang, supportedLangs} from "../../config/i18nConfig";

import it from './lang/it.json'
import BRAND from '../../brand/config';

// brand strings over the base ones: objects are merged, everything else (arrays included) is replaced
const merge = (base, over) => Object.fromEntries(Object.keys({...base, ...over}).map(k => [k,
  over?.[k]?.constructor === Object && base?.[k]?.constructor === Object ? merge(base[k], over[k]) : (k in over ? over[k] : base[k])
]))

const initialState = {
  lang: defaultLang, // "en" when app loads
  supportedLangs: { ...supportedLangs },
  // We'll keep our translations in Redux to start.
  // Later on we'll move them to their own files so
  // that they're easier to manage.
  translations: {
    it: merge(it, BRAND.strings)
  },
};
export const i18nSlice = createSlice({
  name: "i18n",
  initialState,
});
export const selectTranslations = (state) => state.i18n.translations[state.i18n.lang];
export const selectCurrentLang = (state) => state.i18n.lang;

export default i18nSlice.reducer;